import { onChangeCompanyInfo } from "./info-form-helper";
import { onChangeAddressInfo } from "./address-form-helper";
import { splitFirstSpace } from "../../../utils/common-utils";

export const getUpdatedData = (props, cb) => {
  const { type } = props;
  const handlerType = {
    info: () => onChangeCompanyInfo(props, cb),
    "address-info": () => onChangeAddressInfo(props, cb),
  };

  return handlerType[type] && handlerType[type]();
};

export const addressFormData = (address) => {
  if (!address) return {};

  const {
    address1,
    address2,
    city,
    countryCode,
    digitalCode,
    latitude,
    longitude,
    postalCode,
    stateCode,
  } = address;

  const updateAddress = {
    address1,
    address2,
    city,
    countryCode,
    digitalCode,
    postalCode,
    stateCode,
    location: {
      latitude,
      longitude,
    },
  };

  return updateAddress;
};

export const profileFormSubmission = (profileData, addressData, submitted) => {
  let splitFirstName = null;
  let { firstName, lastName, email, profilePicUrl, type } = profileData;

  if (!submitted) {
    splitFirstName = splitFirstSpace(firstName)[1];
    firstName = splitFirstSpace(firstName)[0];
  }

  const {
    city,
    address1,
    stateCode,
    postalCode,
    countryCode,
    digitalCode,
    location: { latitude, longitude },
  } = addressData;

  const formData = {
    firstName,
    lastName: submitted ? lastName : splitFirstName,
    email,
    profilePicUrl,
    type,
    address: {
      address1,
      postalCode,
      city,
      stateCode,
      countryCode,
      latitude,
      longitude,
      digitalCode,
    },
  };

  return formData;
};

export const profileFormPatch = (profileData, addressData, submitted) => {
  const { firstName, lastName, profilePicUrl, type, address } =
    profileFormSubmission(profileData, addressData, submitted);

  const patch = { firstName, lastName };

  if (profilePicUrl) patch.profileImage = profilePicUrl;
  if (type) patch.usage = type;
  if (address && address.latitude != null) patch.address = address;

  return patch;
};

export const profileToFormValues = (profile) => ({
  profilePicUrl: profile?.profileImage ?? "",
  firstName: profile?.firstName ?? "",
  lastName: profile?.lastName ?? "",
  email: profile?.email ?? "",
  phoneNumber: profile?.phoneNumber ?? "",
  type: profile?.usage ?? "",
});
